import {i18n} from "@/plugins/i18n";

export const eventType = {
    MISS_MATCH_AMOUNT: 1,
    MISS_MATCH_CARD_NUMBER: 2,
    MISS_MATCH_TOKEN: 3
}

export const eventTypeStr = {
    MISS_MATCH_AMOUNT : i18n.t('fraud_events.miss_match_amount'),
    MISS_MATCH_CARD_NUMBER : i18n.t('fraud_events.miss_match_card_number'),
    MISS_MATCH_TOKEN : i18n.t('fraud_events.miss_match_token'),
}